import React from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Card, CardContent, CardHeader } from '@material-ui/core';

export const DescriptionCard = () => {
  const { entity } = useEntity();

  return (
    <Card>
      <CardHeader
        title="Description"
        variant="gridItem"
        subheader={entity?.metadata?.description ?? 'Not available'}
      />
      <CardContent />
    </Card>
  );
};
